import React from 'react';
import { DashboardStats } from '../../types/api';
import { useLanguage } from '../../contexts/LanguageContext';

interface KpiRowProps {
  stats: DashboardStats | null;
  isLoading: boolean;
}

/**
 * Сводка кабинета.
 *
 * В макете у каждой плитки есть дельта («+12%») и спарклайн за две
 * недели. Бэк временных рядов не отдаёт вовсе — дашборд возвращает
 * четыре текущих числа. Рисовать спарклайн из выдуманных данных нельзя:
 * это цифры, по которым партнёр принимает решения. Поэтому плитка пока
 * без графика, а запрос на историю метрик записан в
 * docs/BACKEND-EXPECTATIONS.md.
 */
export const KpiRow: React.FC<KpiRowProps> = ({ stats, isLoading }) => {
  const { t } = useLanguage();

  if (isLoading) {
    return (
      <div className="qp-kpi-grid">
        {[0, 1, 2, 3].map((index) => (
          <div key={index} className="qp-skel" style={{ height: 104 }} />
        ))}
      </div>
    );
  }

  if (!stats) return null;

  const tiles = [
    { label: t.cabinet.categoriesInCatalog, value: stats.menu_categories_count, note: t.cabinet.categoriesCountNote },
    { label: t.cabinet.activeDiscounts, value: stats.discounts_count, note: t.cabinet.activeDiscountsNote },
    { label: t.cabinet.rating, value: stats.average_rating ? stats.average_rating.toFixed(1) : '—', note: t.cabinet.ratingNote },
    { label: t.cabinet.reviewsCount, value: stats.reviews_count, note: t.cabinet.reviewsCountNote },
  ];

  return (
    <div className="qp-kpi-grid">
      {tiles.map((tile) => (
        <article key={tile.label} className="qp-kpi">
          <span className="qp-label">{tile.label}</span>
          <p className="qp-kpi-value">{tile.value}</p>
          <span className="qp-kpi-note">{tile.note}</span>
        </article>
      ))}
    </div>
  );
};
